import { convertCookieConsentIntoCategories, getCookieConsent, } from '@/utils/get-cookie-consent';
const cookieAttribute = 'data-cookiecategory';
const scriptSelector = () => {
    return document.querySelectorAll(`script[${cookieAttribute}]`);
};
const manageScripts = () => {
    const acceptedCategories = convertCookieConsentIntoCategories(getCookieConsent());
    const scripts = scriptSelector();
    scripts.forEach((script) => {
        const categoryAsString = script.getAttribute(cookieAttribute);
        const categories = categoryAsString ? categoryAsString.split(',') : [];
        if (acceptedCategories.find((category) => categories.includes(category))) {
            script.type = 'text/javascript';
            script.removeAttribute(cookieAttribute);
            const freshScript = document.createElement('script');
            freshScript.textContent = script.innerHTML;
            script.getAttributeNames().forEach((name) => {
                freshScript.setAttribute(name, script.getAttribute(name));
            });
            if (script.src) {
                freshScript.src = script.src;
            }
            script.parentNode.replaceChild(freshScript, script);
        }
    });
};
export default manageScripts;
